var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"size":"small","title":"应用审核"}},[_c('searchE',{on:{"handleSearch":_vm.handleSubmit}}),_c('tableE',{ref:"branchTable"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }